import { combineReducers } from "redux";
import UserRegistrationSlice from "./UserRegistration/UserRegistrationSlice";
import UserNotificationSlice from "./Notifications/UserNotificationSlice";
import UpdateUserNotificationSlice from "./Notifications/UpdateNotification/UpdateNotificationSlice";
import UserEnrolledDevicesSlice  from "./UserEnrolledDevices/UserEnrolledDevicesSlice";
import UpdateUserEnrolledDeviceDetailsSlice from "./UserEnrolledDeviceDetails/UpdateUserEnrolledDeviceDetailsSlice";
import getUserAddressSlice from "./GetUserAddress/getUserAddressSlice";
import FetchAddressSlice from './ManageAddress/FetchAddress/FetchAddressSlice';
import updateUserAddressSlice from './UpdateUserAddress/UpdateUserAddressSlice';
import UserDeviceRegistrationSlice from "./UserDeviceRegistration/UserDeviceRegistrationSlice";
import UserRolesSlice from "./UserRoles/UserRolesSlice";
import BOLApiTokenslice from "./BOL/BOLApiTokenSlice";
import OrderHistoryLatestSlice from "./OrderHistoryLatest/OrderHistoryLatestSlice";
import NativeAppLogsSlice from "./NativeAppLogs/NativeAppLogsSlice";
import UserEnrollmentFailedDevicesSlice from "./UserEnrollmentFailedDevices/UserEnrollmentFailedDevicesSlice"
import EasyBuySlice from "./EasyBuy/EasyBuySlice"
import CreateUserSupplyOrderSlice from "./OrderEarly/CreateUserSupplyOrder/CreateUserSupplyOrderSlice";
import GetUserSupplyOrderSlice from "./OrderEarly/GetSupplyOrderStatus/GetSupplyOrderStatusSlice"
import GetNewPrinterBundleServicePlanSlice from "./HardwareInclusive/GetNewPrinterBundleServicePlanSlice"

export default combineReducers({
    GetUserRegistrationService: UserRegistrationSlice,
    GetUserNotificationService:UserNotificationSlice,
    UpdateUserNotificationsService: UpdateUserNotificationSlice,
    GetUserEnrolledDevicesService: UserEnrolledDevicesSlice,
    UpdateUserEnrolledDeviceDetails:UpdateUserEnrolledDeviceDetailsSlice,
    getUserAddress:getUserAddressSlice,
    fetchAddressService:FetchAddressSlice,
    updateUserAddressService:updateUserAddressSlice,
    GetUserDeviceRegistrationService: UserDeviceRegistrationSlice,
    GetUserRolesService: UserRolesSlice,
    FetchToken: BOLApiTokenslice,
    OrderHistoryLatestService: OrderHistoryLatestSlice,
    StoreNativeAppLogs: NativeAppLogsSlice,
    GetUserEnrollmentFailedDevicesService: UserEnrollmentFailedDevicesSlice,
    EasyBuy:EasyBuySlice,
    CreateUserSupplyOrder:CreateUserSupplyOrderSlice,
    GetSupplyOrderStatus:GetUserSupplyOrderSlice,
    GetNewPrinterBundleServicePlan: GetNewPrinterBundleServicePlanSlice
})